<div class="modal fade" [class.show]="isVisible" [style.display]="isVisible ? 'block' : 'none'" tabindex="-1" role="dialog">
  <div class="modal-dialog modal-lg" role="document">
    <div class="modal-content">
      <!-- Modal Header -->
      <div class="modal-header">
        <h5 class="modal-title">
          <i class="fas fa-exchange-alt me-2"></i>
          Transferir Item
        </h5>
        <button type="button" class="btn-close" (click)="closeModal()" aria-label="Close"></button>
      </div>

      <!-- Modal Body -->
      <div class="modal-body">
        <!-- Item Information -->
        <div *ngIf="item" class="item-info-section mb-4">
          <h6 class="section-title">
            <i class="fas fa-box me-2"></i>
            Item a ser Transferido
          </h6>
          <div class="row g-3">
            <div class="col-md-6">
              <div class="info-item">
                <label class="form-label">Código</label>
                <div class="info-value">{{ item.code }}</div>
              </div>
            </div>
            <div class="col-md-6">
              <div class="info-item">
                <label class="form-label">Nome</label>
                <div class="info-value">{{ item.name }}</div>
              </div>
            </div>
            <div class="col-md-6">
              <div class="info-item">
                <label class="form-label">Estoque Atual</label>
                <div class="info-value">{{ item.stockName || 'N/A' }}</div>
              </div>
            </div>
            <div class="col-md-6">
              <div class="info-item">
                <label class="form-label">Almoxarifado Atual</label>
                <div class="info-value">{{ item.warehouseName || 'N/A' }}</div>
              </div>
            </div>
            <div class="col-md-6">
              <div class="info-item">
                <label class="form-label">Quantidade Atual</label>
                <div class="info-value">{{ item.quantity }} {{ item.unit || '' }}</div>
              </div>
            </div>
            <div class="col-md-6">
              <div class="info-item">
                <label class="form-label">Status Atual</label>
                <div class="info-value">
                  <span class="badge" [class]="getStatusClass(item.status || '')">
                    {{ item.status }}
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Transfer Type Selection -->
        <div class="transfer-type-section mb-4">
          <h6 class="section-title">
            <i class="fas fa-cogs me-2"></i>
            Tipo de Transferência
          </h6>
          <div class="transfer-type-options">
            <div class="transfer-type-option" 
                 *ngFor="let type of transferTypes"
                 [class.selected]="transferType === type.value"
                 (click)="setTransferType(type.value)">
              <div class="option-header">
                <div class="option-icon">
                  <i [class]="getTransferTypeIcon(type.value)"></i>
                </div>
                <div class="option-content">
                  <h6 class="option-title">{{ type.label }}</h6>
                  <p class="option-description">{{ type.description }}</p>
                </div>
                <div class="option-radio">
                  <input type="radio" name="transferType" [value]="type.value" [checked]="transferType === type.value">
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Transfer Form -->
        <form [formGroup]="form" (ngSubmit)="validateTransfer()">
          <!-- Target Stock (for Complete and Partial transfers) -->
          <div *ngIf="transferType === 'Complete' || transferType === 'Partial'" class="mb-3">
            <label for="targetStockId" class="form-label">
              <i class="fas fa-warehouse me-1"></i>
              Estoque de Destino <span class="text-danger">*</span>
            </label>
            <select 
              id="targetStockId"
              class="form-select"
              formControlName="targetStockId"
              [class.is-invalid]="form.get('targetStockId')?.invalid && form.get('targetStockId')?.touched">
              <option value="">Selecione o estoque de destino</option>
              <option *ngFor="let stock of stocks" [value]="stock.id">
                {{ stock.name }} ({{ stock.code }})
              </option>
            </select>
            <div *ngIf="form.get('targetStockId')?.invalid && form.get('targetStockId')?.touched" class="invalid-feedback">
              Estoque de destino é obrigatório
            </div>
          </div>

          <!-- Target Warehouse (optional) -->
          <div *ngIf="transferType === 'Complete' || transferType === 'Partial'" class="mb-3">
            <label for="targetWarehouseId" class="form-label">
              <i class="fas fa-building me-1"></i>
              Almoxarifado de Destino
            </label>
            <select 
              id="targetWarehouseId"
              class="form-select"
              formControlName="targetWarehouseId">
              <option value="">Selecione o almoxarifado de destino (opcional)</option>
              <option *ngFor="let warehouse of warehouses" [value]="warehouse.id">
                {{ warehouse.name }} ({{ warehouse.code }})
              </option>
            </select>
          </div>

          <!-- Quantity (for Partial transfers) -->
          <div *ngIf="transferType === 'Partial'" class="mb-3">
            <label for="quantity" class="form-label">
              <i class="fas fa-hashtag me-1"></i>
              Quantidade a Transferir <span class="text-danger">*</span>
            </label>
            <div class="input-group">
              <input 
                type="number"
                id="quantity"
                class="form-control"
                formControlName="quantity"
                step="0.01"
                min="0.01"
                [max]="item?.quantity || 0"
                placeholder="Digite a quantidade"
                [class.is-invalid]="form.get('quantity')?.invalid && form.get('quantity')?.touched">
              <span class="input-group-text">{{ item?.unit || 'un' }}</span>
            </div>
            <div *ngIf="form.get('quantity')?.invalid && form.get('quantity')?.touched" class="invalid-feedback">
              Quantidade é obrigatória e deve ser maior que zero
            </div>
            <div *ngIf="item" class="form-text">
              Quantidade disponível: {{ item.quantity }} {{ item.unit || 'un' }}
            </div>
          </div>

          <!-- New Location (for Location transfers) -->
          <div *ngIf="transferType === 'Location'" class="mb-3">
            <label for="newLocation" class="form-label">
              <i class="fas fa-map-marker-alt me-1"></i>
              Nova Localização <span class="text-danger">*</span>
            </label>
            <input 
              type="text"
              id="newLocation"
              class="form-control"
              formControlName="newLocation"
              placeholder="Digite a nova localização"
              [class.is-invalid]="form.get('newLocation')?.invalid && form.get('newLocation')?.touched">
            <div *ngIf="form.get('newLocation')?.invalid && form.get('newLocation')?.touched" class="invalid-feedback">
              Nova localização é obrigatória
            </div>
          </div>

          <!-- New Shelf (for Location transfers) -->
          <div *ngIf="transferType === 'Location'" class="mb-3">
            <label for="newShelf" class="form-label">
              <i class="fas fa-layer-group me-1"></i>
              Nova Prateleira
            </label>
            <input 
              type="text"
              id="newShelf"
              class="form-control"
              formControlName="newShelf"
              placeholder="Digite a nova prateleira (opcional)">
          </div>

          <!-- New Rack (for Location transfers) -->
          <div *ngIf="transferType === 'Location'" class="mb-3">
            <label for="newRack" class="form-label">
              <i class="fas fa-th me-1"></i>
              Novo Rack
            </label>
            <input 
              type="text"
              id="newRack"
              class="form-control"
              formControlName="newRack"
              placeholder="Digite o novo rack (opcional)">
          </div>

          <!-- Reason -->
          <div class="mb-3">
            <label for="reason" class="form-label">
              <i class="fas fa-question-circle me-1"></i>
              Motivo da Transferência
            </label>
            <input 
              type="text"
              id="reason"
              class="form-control"
              formControlName="reason"
              placeholder="Digite o motivo da transferência (opcional)"
              maxlength="200">
            <div class="form-text">
              {{ form.get('reason')?.value?.length || 0 }}/200 caracteres
            </div>
          </div>

          <!-- Notes -->
          <div class="mb-3">
            <label for="notes" class="form-label">
              <i class="fas fa-sticky-note me-1"></i>
              Observações
            </label>
            <textarea 
              id="notes"
              class="form-control"
              formControlName="notes"
              rows="3"
              placeholder="Digite observações adicionais (opcional)"
              maxlength="1000"></textarea>
            <div class="form-text">
              {{ form.get('notes')?.value?.length || 0 }}/1000 caracteres
            </div>
          </div>

          <!-- Validation Errors -->
          <div *ngIf="validationErrors.length > 0" class="alert alert-danger">
            <h6 class="alert-heading">
              <i class="fas fa-exclamation-triangle me-2"></i>
              Erros de Validação
            </h6>
            <ul class="mb-0">
              <li *ngFor="let error of validationErrors">{{ error }}</li>
            </ul>
          </div>
        </form>
      </div>

      <!-- Modal Footer -->
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" (click)="closeModal()" [disabled]="isSubmitting">
          <i class="fas fa-times me-2"></i>
          Cancelar
        </button>
        <button 
          type="button" 
          class="btn btn-primary" 
          (click)="validateTransfer()"
          [disabled]="!isFormValid() || isSubmitting || isLoading">
          <span *ngIf="isLoading" class="spinner-border spinner-border-sm me-2" role="status"></span>
          <span *ngIf="isSubmitting" class="spinner-border spinner-border-sm me-2" role="status"></span>
          <i *ngIf="!isLoading && !isSubmitting" class="fas fa-check me-2"></i>
          {{ isLoading ? 'Validando...' : isSubmitting ? 'Transferindo...' : 'Transferir Item' }}
        </button>
      </div>
    </div>
  </div>
</div>

<!-- Modal Backdrop -->
<div *ngIf="isVisible" class="modal-backdrop fade show"></div>
